import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import theme from '../../theme';

const useStyles = makeStyles({
    root: {
        width: '100%',
        padding: '20px 10px',
        margin: '10px 0px 0px',
        // backgroundColor: theme.palette.primary.main,
        borderRadius: '0px',
    },

})

export type NoItemsProps = {
    name: string
}

const NoItems = (props: NoItemsProps) => {
    const classes = useStyles();

    return (
        <>
            <Box className={classes.root}>
                <Typography variant='h5' align='center' color='textSecondary'>
                    There are no {props.name} yet.
                </Typography>
            </Box>
        </>
    )
}

export default NoItems;